import React from 'react'

function PolicyManagement() {
  return (
    <div></div>
  )
}

export default PolicyManagement
